// extracted by mini-css-extract-plugin
module.exports = {"column":"styles_column__aaIY2","city":"styles_city__UlIFC","text":"styles_text__O7h6_"};